import React from 'react';
import { colorPalette } from '../../../colorPalette';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
export const MonthlyPayment = ({ monthlyPayment, hasMultiplePrices, dataQa, onMonthlyPaymentClick }) => {
    return (React.createElement(Stack, { direction: "row", alignItems: "center", component: "div", "data-qa": dataQa, sx: {
            cursor: 'pointer',
            padding: '0px 4px',
            lineHeight: '18px',
            height: '18px',
        }, onClick: onMonthlyPaymentClick },
        React.createElement(Typography, { variant: "caption", fontSize: "12px" }, "Ou"),
        hasMultiplePrices && (React.createElement(Typography, { variant: "caption", fontSize: "12px" },
            ' ',
            "d\u00E8s")),
        React.createElement(Typography, { sx: {
                color: colorPalette.red800,
            }, variant: "caption", padding: "0 4px", fontSize: "14px", fontWeight: 600 },
            monthlyPayment,
            "\u20AC"),
        React.createElement(Typography, { variant: "caption", fontSize: "12px" }, "/mois")));
};
